export enum ModalActions {
    'add-edit' = 'add-edit',
    'edit' = 'edit',
    'delete' = 'delete',
  }
